import {
    deleteFilesLoading,
    deleteFilesRequest,
    deleteFilesSuccess,
    deleteFilesReject,
    deleteFilesReset
} from "../../actions/filesRoute/delete";

export const deleteFiles = (formData) => async (dispatch, getState) => {
    dispatch(deleteFilesLoading());
    try {
        const { data } = await deleteFilesRequest(formData, getState);
        dispatch(deleteFilesSuccess(data))
    } catch (error) {
        dispatch(deleteFilesReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteFilesReset()) }, 3000);
    }
    return Promise.resolve();
};